import { ChangeDetectionStrategy, Component, inject, input, InputSignal } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { UpperFirstLetterPipe } from '../../pipes/upper-first-letter-pipe';
import { IconComponent } from '@kinomap-dev/ng-ui-lib/basics';

@Component({
  selector: 'app-empty-content-list-element',
  imports: [IconComponent, TranslateModule, UpperFirstLetterPipe],
  templateUrl: './empty-content-list-element.html',
  styleUrl: './empty-content-list-element.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EmptyContentListElement {
  public router: Router = inject(Router);
  readonly contentType: InputSignal<string | undefined> = input<string | undefined>();
}
